import { VisibilityOffOutlined } from '@mui/icons-material'
import { DraftQuestionnaireEntry } from '../../../data/model/questionnaire'
import { QuestionnaireHeaderChip } from '../HeaderLabels/QuestionnaireHeaderChip'
import { useWaveVisibility } from './useWaveVisibility'
import { waveVisibilityLabel } from './waveVisibility'

export const WaveVisibilityIndicator = ({
  entryItem
}: {
  entryItem: DraftQuestionnaireEntry['entryItem']
}) => {
  const label = waveVisibilityLabel(useWaveVisibility(entryItem))
  if (!label) return null

  return (
    <QuestionnaireHeaderChip
      // cin-ui has no closed-eye icon; this matches its large emphasis icons.
      icon={<VisibilityOffOutlined color="secondary" />}
    >
      {label}
    </QuestionnaireHeaderChip>
  )
}
